import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

class Steps extends Component {

    constructor(props){
        super(props)
        
        this.state = {

        }
    }

    render(){
        const { match, location, history } = this.props
        
        return(
            <div className={window.location.href.indexOf("dashboard") > -1 ? 'd-none' : 'Steps'}>
                <ul>
                    <li className={location.pathname === '/' || window.location.href.indexOf("payment") > -1 || location.pathname === '/payment' || location.pathname === '/register' || location.pathname === '/login' ? 'active' : ''}><span>1</span></li>
                    <li className={location.pathname === '/register' || window.location.href.indexOf("payment") > -1 || location.pathname === '/payment' || location.pathname === '/login' ? 'active' : ''}><span>2</span></li>
                    <li className={location.pathname === '/payment' || window.location.href.indexOf("payment") > -1 ? 'active' : ''}><span>3</span></li>
                </ul>
            </div>
        )
    }
}
export default withRouter(Steps);